import firstWay from './firstWay'
import secondWay from './secondWay'
import thirdWay from './thirdWay'

const steps = {
    '0': {
        next: ['1', '2', '3']
    },
    ...firstWay,
    ...secondWay,
    ...thirdWay
}

export default steps